<div>
    <div class="heatmap-container">
        <div class="title-container">
            <label style="font-size: 18px; margin: 10px;">
                {{ event?.name }}
            </label>
            <button class="btn btn-danger" style="padding: 0 0.5rem 0 0.5rem; margin: 10px;" (click)="reset()">Reset</button>
        </div>
        <div style="background-color: whitesmoke; padding: 15px">
            <canvas 
                #heatmapRef 
                class="canvas"
                (mousewheel)="onZoom($event)"
                (mousemove)="move($event)"
                (mouseenter)="onMouseEnter()"
                (mouseleave)="onMouseExit()"
                ></canvas>
            <span #tooltip *ngIf="shouldDisplayTooltip" class="mouse-tooltip">{{tooltipPosition | date: 'MMM d, y, h:mm:ss a'}}</span>
        </div>
        <div class="label-container">
            <div style="margin: 10px;">
                <label style="margin-right: 1em;">
                    Range Start: 
                </label>
                <input type="datetime-local" [value]="displayStart | date:'yyyy-MM-ddTHH:mm'" (change)="onRangeChange($event, false)"/>
            </div>
            <div style="margin: 10px;">
                <label style="margin-right: 1em;">
                    Range End: 
                </label>
                <input type="datetime-local" [value]="displayEnd | date:'yyyy-MM-ddTHH:mm'" (change)="onRangeChange($event, true)"/>
            </div>
        </div>
    </div>
</div>